import React from "react";
import { faqs } from "../../Data/faq";
import { Accordion } from "react-bootstrap";
import AccordionItem from "./AccordionItem";

const CustomAccordion = () => {
  return (
    <div>
      <Accordion defaultActiveKey="0" flush>
        <AccordionItem />
      </Accordion>
    </div>
  );
};

export default CustomAccordion;
